import { render, staticRenderFns } from "./AssignGroupsForm.vue?vue&type=template&id=124d2fc6"
import script from "./AssignGroupsForm.vue?vue&type=script&lang=js"
export * from "./AssignGroupsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports